import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Hidden from "@material-ui/core/Hidden";
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Snackbar from '@material-ui/core/Snackbar';

import CardGrid from './CardGrid';
import IdeaSelector from './IdeaSelector';
import ChipBasedSelector from './ChipBasedSelector';
import { IdeaOptions, MasteryChipOptions, SupportSkillChipOptions, UnitOptions, CharacterOptions, DistributionTypeOptions } from '../data/ConstData';
import { AppVersion, DataVersion } from '../data/Version';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
        display: "none",
    },
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: 'auto',
  },
  dataDate: {
    paddingTop: '5px',
    paddingBottom: '5px',
  },
  accordionHeading: {
    textAlign: 'start',
    fontSize: theme.typography.pxToRem(15),
  },
  characterSelectorAccordion: {
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: 0,
  },
  cautionText: {
    padding: '8px',
    fontSize: theme.typography.pxToRem(13),
  },
  imageOnlyBox: {
    textAlign: 'center'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
}));

export default function AppDrawer(props) {
  const { window } = props;
  const container = window !== undefined ? () => window().document.body : undefined;
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [imageOnlyMode, setImageOnlyMode] = React.useState(false);
  const handleImageOnly = (e) => {
    setImageOnlyMode(e.target.checked);
  }
  const [textOnlyMode, setTextOnlyMode] = React.useState(false);
  const handleTextOnly = (e) => {
    setTextOnlyMode(e.target.checked);
  }

  const [TFDFilter, setTFDFilter] = React.useState('any');
  const [GRADFilter, setGRADFilter] = React.useState('any');
  const [characterFilter, setCharacterFilter] = React.useState([]);
  const [masteryFilter, setMasteryFilter] = React.useState([]);
  const [skillFilter, setSkillFilter] = React.useState([]);
  const [distributionFilter, setDistributionFilter] = React.useState([]);

  const onIdeaTFDChange = (selection) => {
    setTFDFilter(selection);
  };
  const onIdeaGRADChange = (selection) => {
    setGRADFilter(selection);
  };

  const onCharacterSelectionChange = (searchFilter) => {
    if (characterFilter.includes(searchFilter)) {
      const newFilter = characterFilter.filter(d => d !== searchFilter);
      setCharacterFilter(newFilter);
    } else {
      setCharacterFilter([...characterFilter, searchFilter]);
    }
  };

  const onMasterySelectionChange = (seachFilter) => {
    if (masteryFilter.includes(seachFilter)) {
      // 削除する場合 searchFilterとして来た文字列と一致しないもののみ返すようにフィルタ
      const newFilter = masteryFilter.filter(d => d !== seachFilter);
      setMasteryFilter(newFilter);
    } else {
      // 足す場合
      setMasteryFilter([...masteryFilter, seachFilter]);
    }
  };

  const onSkillSelectionChange = (seachFilter) => {
    if (skillFilter.includes(seachFilter)) {
      // 削除 searchFilterとして来た文字列と一致しないもののみ返すようにフィルタ
      const newFilter = skillFilter.filter(d => d !== seachFilter);
      setSkillFilter(newFilter);
    } else {
      setSkillFilter([...skillFilter, seachFilter]);
    }
  };

  const onDistributionSelectionChange = (searchFilter) => {
    if (distributionFilter.includes(searchFilter)) {
      const newFilter = distributionFilter.filter(d => d !== searchFilter);
      setDistributionFilter(newFilter);
    } else {
      setDistributionFilter([...distributionFilter, searchFilter]);
    }
  };

  const [snackbarVisibility, setSnackbarVisibility] = React.useState(true);
  const handleSnackbarClose = (event, reason) => {
    setSnackbarVisibility(false);
  }

  const drawer = (
    <div className={classes.drawerContainer}>
      <Hidden xsDown implementation="css">
        <Toolbar variant='dense'/>
      </Hidden>
      <Typography align="center" className={classes.dataDate}>(データ: {DataVersion}時点)</Typography>
      <Accordion square>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="Character filter"
          id="accordion-character-filter">
            <Typography className={classes.accordionHeading}>キャラ<br />(選択中: <strong>{characterFilter.join("・")}</strong>)</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.characterSelectorAccordion}>
            {UnitOptions.map((unit) => {
              return (
                  <ChipBasedSelector key={unit} padding='0px 14px 7px 14px' ideaData={CharacterOptions.filter(c => c.unit === unit)} onSelectionChange={onCharacterSelectionChange}/>
              )
            })}
          </AccordionDetails>
      </Accordion>
      <Accordion square>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="Character filter"
          id="accordion-tfd-filter">
            <Typography className={classes.accordionHeading}>感謝祭アイディア (選択中: <strong>{TFDFilter}</strong>)</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.characterSelectorAccordion}>
            <IdeaSelector ideaOptions={IdeaOptions} onSelectionChange={onIdeaTFDChange} />
          </AccordionDetails>
      </Accordion>
      <Accordion square>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="Character filter"
          id="accordion-tfd-filter">
            <Typography className={classes.accordionHeading}>G.R.A.Dひらめき (選択中: <strong>{GRADFilter}</strong>)</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.characterSelectorAccordion}>
            <IdeaSelector ideaOptions={IdeaOptions.filter(x => x.idea !== 'SP')} onSelectionChange={onIdeaGRADChange} />
          </AccordionDetails>
      </Accordion>
      <Accordion square>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="Character filter"
          id="accordion-tfd-filter">
            <Typography className={classes.accordionHeading}>マスタリー<br />(選択中: <strong>{masteryFilter.join("・")}</strong>)</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.characterSelectorAccordion}>
            <ChipBasedSelector ideaData={MasteryChipOptions} onSelectionChange={onMasterySelectionChange} />
          </AccordionDetails>
      </Accordion>
      <Accordion square>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="Character filter"
          id="accordion-tfd-filter">
            <Typography className={classes.accordionHeading}>その他スキル<br />(選択中: <strong>{skillFilter.join("・")}</strong>)</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.characterSelectorAccordion}>
            <ChipBasedSelector ideaData={SupportSkillChipOptions} onSelectionChange={onSkillSelectionChange} />
          </AccordionDetails>
      </Accordion>
      <Accordion square>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="Card distribution type filter"
          id="accordion-tfd-filter">
            <Typography className={classes.accordionHeading}>カード登場種別<br />(選択中: <strong>{distributionFilter.join("・")}</strong>)</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.characterSelectorAccordion}>
            <ChipBasedSelector ideaData={DistributionTypeOptions} onSelectionChange={onDistributionSelectionChange} />
          </AccordionDetails>
      </Accordion>
      <Box className={classes.imageOnlyBox}>
        <FormControlLabel
          control={<Checkbox checked={imageOnlyMode} onChange={handleImageOnly} name="imageOnly" />}
          label="画像だけ"
        />
        <FormControlLabel
          control={<Checkbox checked={textOnlyMode} onChange={handleTextOnly} name="textOnly" />}
          label="文字だけ"
        />
      </Box>
      <Box>
        <Typography align='center' className={classes.cautionText}>
          使用自己責任の非公式ツールです。画像の著作権は権利者様に帰属しています。権利者様からの削除依頼・警告には速やかに対応いたします。連絡先Twitter: nok0714
        </Typography>
      </Box>
    </div>
  );

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar variant='dense'>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            シャニマスsSSR検索機(v{AppVersion})
          </Typography>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="condition selectors">
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor="left"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{paper: classes.drawerPaper,}}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            { drawer }
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{paper: classes.drawerPaper,}}
            variant="permanent"
            open
          >
            { drawer }
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <Toolbar variant='dense' />
        <CardGrid
          TFDFilter={TFDFilter}
          GRADFilter={GRADFilter}
          masteryFilter={masteryFilter}
          skillFilter={skillFilter}
          characterFilter={characterFilter}
          distributionFilter={distributionFilter}
          imageOnlyMode={imageOnlyMode}
          textOnlyMode={textOnlyMode} />
        <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={snackbarVisibility}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        message="検索条件を無視してカードを表示する場合は、ホールドボタンを押してください。"
      />
      </main>
    </div>
  );
}